import React from "react";

import { SharedCurrentUser } from "../../../lib/types";

import { Box, Link, Text } from "@chakra-ui/react";
import { DrawerListItem } from "./DrawerListItem";

export const DrawerProfileMenu = ({ currentUser }: { currentUser: NonNullable<SharedCurrentUser> }) => {
  return (
    <>
      <Box px={5}>
        <Text fontSize="sm" fontWeight="bold">
          プロフィール
        </Text>
        <Box mt={2}>
          {currentUser.header_profile_menu_items.map(({ label, href }, index) => (
            <DrawerListItem as={Link} href={href} key={index}>
              {label}
            </DrawerListItem>
          ))}
        </Box>
      </Box>
      <Box as="hr" mt={2} />
    </>
  );
};
